export default "__VITE_ASSET__DXQ$9LG8__"